import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Lead } from 'src/app/domains/sales/lead/models/lead.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class LeadService {
  constructor(private http: HttpClient) {}

  submitLead(lead: Lead) {
    const headers = new HttpHeaders().set(
      'Content-type',
       'application/x-www-form-urlencoded'
    );
    let url: string;
    switch (lead.country) {
      case 'GB':
        url = environment.newLeadRequestUrlGB;
        break;
      case 'US':
        url = environment.newLeadRequestUrlUS;
        break;
      case 'IT':
      default:
        url = environment.newLeadRequestUrlIT;
    }
    return this.http.post(
      url,
      JSON.stringify(lead),
      { headers }
    );
  }
}
